import { render, staticRenderFns } from "./mainBanner.vue?vue&type=template&id=19a49cba&scoped=true&"
import script from "./mainBanner.vue?vue&type=script&lang=js&"
export * from "./mainBanner.vue?vue&type=script&lang=js&"
import style0 from "./mainBanner.vue?vue&type=style&index=0&id=19a49cba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a49cba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VFlex,VIcon,VImg,VLayout,VSnackbar})
